import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import sustainibility from "../../Assets/Projects/sustainibility-bites.png";
import newsiee from "../../Assets/Projects/newsiee.png";
import Portfolio from "../../Assets/Projects/Portfolio-Sample.png";
import recommender from "../../Assets/Projects/Movie-recommender.png";
import speech from "../../Assets/Projects/text-to-speech.png";
import database from "../../Assets/Projects/database-mongo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={newsiee}
              isBlog={false}
              title="NEWSIEE"
              description="NEWSIEE is an innovative project combining AI, ML, and interactive features to revolutionize news consumption with summarization, deepfake detection, audio, and community engagement tools."
              ghLink="https://github.com/chayanC7mondal/HACKINNO"
              demoLink="https://youtu.be/9ry3XrWlpMg?si=LFNcPC8yVYDM8hcu"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sustainibility}
              isBlog={false}
              title="SUSTAINIBILITY-BITES"
              description="Sustainability Bites connects restaurants and food donors, predicts food surplus, forecasts AQI for cities, and anticipates future energy usage, aiding in sustainable resource management and decision-making."
              ghLink="https://github.com/chayanC7mondal/HackNITR5.0"
               demoLink="https://youtu.be/bXMK3iLsqks?si=5OUY5gt1C-So1r2F"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Portfolio}
              isBlog={false}
              title="PORTFOLIO-WEBSITE"
              description="I developed a responsive portfolio website for a professor using HTML, CSS, and JavaScript. It showcases academic achievements, research, publications, and includes interactive, user-friendly features."
              ghLink="https://github.com/chayanC7mondal/PORTFOLIO_SAMPLE"
              demoLink="https://portfolio-sample-virid.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={recommender}
              isBlog={false}
              title="MOVIE-RECOMMENDER"
              description="Developed a movie recommender system using machine learning, leveraging user preferences and behavior to suggest personalized movie recommendations with high accuracy and relevance."
              ghLink="https://github.com/chayanC7mondal/Movie-Recommender"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={speech}
              isBlog={false}
              title="TEXT-TO-SPEECH"
              description="Developed a JavaScript-based text-to-speech model that converts text into speech, supporting multiple languages and accents, enhancing accessibility and user experience."
              ghLink="https://github.com/chayanC7mondal/Text--To--Voice"
               demoLink="https://chayanc7mondal.github.io/Text--To--Voice/"  /> 
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={database}
              isBlog={false}
              title="STUDENT-DATABASE"
              description="Created a student database form using MongoDB, HTML, CSS, and JavaScript, enabling efficient data entry, storage, and retrieval with a user-friendly interface and real-time validation."
              ghLink="https://github.com/chayanC7mondal/Student-Registration-Form"
               demoLink="https://student-registration-form-flax.vercel.app/" 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
